import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=0ae9d8b7"
var script = {}
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=0ae9d8b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports